export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-ko-KR.ad5dd8e3.xlsx";